import { render, staticRenderFns } from "./ViewText.vue?vue&type=template&id=12486c94&scoped=true"
import script from "./ViewText.vue?vue&type=script&lang=js"
export * from "./ViewText.vue?vue&type=script&lang=js"
import style0 from "./ViewText.vue?vue&type=style&index=0&id=12486c94&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12486c94",
  null
  
)

export default component.exports